<template>
    <aside v-if="isVisible" class="legacy-app-notice" role="alert" aria-labelledby="legacy-app-notice-title">
        <div class="legacy-app-notice__message">
            <strong id="legacy-app-notice-title">Binnenkort alleen via de Zorgbord-app</strong>
            <span>Deze webomgeving is verouderd en wordt binnenkort gesloten. Stap daarom op tijd over naar de mobiele app.</span>
            <span class="legacy-app-notice__contact">Vragen? Bel <a href="tel:+31687870085">06 87870085</a>.</span>
        </div>

        <div class="legacy-app-notice__actions" aria-label="Download de Zorgbord-app">
            <a
                href="https://apps.apple.com/nl/app/zorgbord/id1607535926"
                target="_blank"
                rel="noopener noreferrer"
            >iOS</a>
            <a
                href="https://play.google.com/store/apps/details?id=com.zorgbord.app.diensten&amp;pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
            >Android</a>
        </div>

        <button
            class="legacy-app-notice__close"
            type="button"
            aria-label="Melding sluiten"
            @click="dismiss"
        >&times;</button>
    </aside>
</template>

<script>
const DISMISSED_STORAGE_KEY = 'legacy-app-notice-dismissed';

export default {
    name: 'legacy-app-notice',
    data() {
        return {
            isVisible: false
        };
    },
    mounted() {
        try {
            this.isVisible = window.localStorage.getItem(DISMISSED_STORAGE_KEY) !== 'true';
        } catch (error) {
            this.isVisible = true;
        }
    },
    methods: {
        dismiss() {
            this.isVisible = false;

            try {
                window.localStorage.setItem(DISMISSED_STORAGE_KEY, 'true');
            } catch (error) {
                // The notice still closes when storage is unavailable.
            }
        }
    }
};
</script>

<style lang="scss">
@import "~styles/_vars.scss";

.legacy-app-notice {
    position: fixed;
    top: 87px;
    left: 50%;
    z-index: 997;
    display: flex;
    width: calc(100% - 32px);
    max-width: 980px;
    padding: 12px 48px 12px 16px;
    color: $black;
    background: #fff8dc;
    border: 1px solid #e7c85a;
    border-radius: 6px;
    box-shadow: 0 3px 12px rgba(0, 20, 33, 0.18);
    transform: translateX(-50%);
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    &__message {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        gap: 2px 8px;
        font-size: 14px;
        line-height: 20px;
    }

    &__contact {
        white-space: nowrap;
    }

    &__actions {
        display: flex;
        flex-shrink: 0;
        gap: 8px;

        a {
            min-width: 76px;
            padding: 7px 12px;
            color: $white !important;
            background: $primary-color;
            border-radius: 4px;
            font-size: 13px;
            font-weight: 500;
            line-height: 18px;
            text-align: center;
            text-decoration: none;

            &:hover,
            &:focus {
                background: darken($primary-color, 7%);
            }
        }
    }

    &__close {
        position: absolute;
        top: 8px;
        right: 10px;
        width: 30px;
        height: 30px;
        padding: 0;
        color: $black;
        background: transparent;
        border: 0;
        border-radius: 4px;
        font-size: 26px;
        line-height: 28px;
        cursor: pointer;

        &:hover,
        &:focus {
            background: rgba(0, 20, 33, 0.08);
        }
    }
}

@media (max-width: 700px) {
    .legacy-app-notice {
        top: 83px;
        width: calc(100% - 20px);
        padding: 40px 12px 10px;
        align-items: stretch;
        flex-direction: column;
        gap: 8px;

        &__message {
            display: block;
            font-size: 13px;
            line-height: 18px;

            strong,
            span {
                display: block;
            }
        }

        &__actions a {
            flex: 1;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/legacy-app-notice.vue